import React from 'react';
import { hoverHelpers } from 'shared-helpers';

import { getEntityProfileUrl } from '/src/components/ICESections/Shared/helpers';
import AmplitudeHelperClass from '/src/lib/amplitudeHelper';

const amplitudeHelper = new AmplitudeHelperClass();

const EntityLink = ({ entity, hasDirAccess }) => {
    if (!entity?.name) return <span>N/A</span>;

    const entityUrl = getEntityProfileUrl(entity);

    return (
        <div className="structured-investments-table__entity">
            {entityUrl ? (
                <a
                    href={entityUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="structured-investments-table__entity-link"
                    onClick={() => amplitudeHelper.trackEvent('Funding Round Click to Profile')}
                    onMouseEnter={(event) => hoverHelpers.handleEntityHover(entity, event, hasDirAccess)}
                    onMouseLeave={() => hoverHelpers.handleMouseOut()}
                >
                    {entity.name}
                </a>
            ) : (
                <span
                    className="structured-investments-table__entity-link"
                    onMouseEnter={(event) => hoverHelpers.handleEntityHover(entity, event, hasDirAccess)}
                    onMouseLeave={() => hoverHelpers.handleMouseOut()}
                >
                    {entity.name}
                </span>
            )}
        </div>
    );
};

export default EntityLink;
